"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'socialMediaPlan.tab.posts': '帖子',
    'socialMediaPlan.tab.calendar': '日历',
    'socialMediaPlan.tab.history': '活动',
};
